import { useHistory } from 'react-router-dom'

import WarningIcon from '../../assets/Warning'
import TriangleIcon from '../../assets/alert-img-already-ex.png'
import Header from 'components/Header/header'
import style from './exigencyStyles.module.css'
import React from 'react'

function UserAlreadyRegistered({
    studentMobNum,
    studentDetails,
    studentRegister,
    backToNewRegister
}) {

    const [showCredentails, setshowCredentails] = React.useState(false)
    const maskedMobNum = (userMobileNum) => {
        const first2Digits = userMobileNum.substring(0, 2);
        const last2Digits = userMobileNum.substring(userMobileNum.length - 2);
        const maskedMiddle = 'X'.repeat(userMobileNum.length - 4);
        return `${first2Digits}${maskedMiddle}${last2Digits}`;
    }
    const Domain = window.location.hostname 

    return (
        <>
            <div className="mb-3">
                <Header />
            </div>
            {!showCredentails ? (
                <div className="d-flex flex-column justify-content-center align-items-center vh-80">
                    <div className="w-7 text-center">
                        <img src={TriangleIcon} alt="warning" />
                        <p className="fw-lighter font-size-lg mt-3 mb-3 text-error-red">
                            You are already registered with mobile number <br />
                            <span className="text-dark-grey"> {maskedMobNum(studentMobNum)}</span>
                        </p>
                    </div>

                    <div className="bg-light-pink text-brown rounded p-2 m-3 mb-4 px-4">
                        <span className="font-size-md text-error-red fw-500">
                            {Domain.includes('akthedashboard') ? 'Please use different mobile number to register for your AKTHE exam' : ' Please use different mobile number to register for your ANTHE exam'}
                        </span>
                    </div>

                    <div className="bg-light text-brown rounded p-2 m-3 pe-5 ps-4">
                        <span className="font-size-sm text-grey-black">
                            To view roll number and password for {maskedMobNum(studentMobNum)}{' '}
                            <span className="text-aqua cursor-pointer" onClick={()=>{
                                setshowCredentails(true)
                            }}>
                                <u>click here</u>
                            </span>
                        </span>
                    </div>

                    <div
                        className={`${style.exigency_shadow} text-brown rounded p-4 mt-5 text-center `}
                    >
                        <span className="font-size-sm ms-4 mx-4 text-grey-black lh-xl mt-1">
                            Click below to create new registration
                        </span>
                        <button
                            className={`btn btn-aqua text-white w-9 w-md-5 w-lg-2 font-size-md fw-lighter rounded-10px mt-xs-3`}
                            style={{ padding: '11px' }}
                            onClick={() => {
                                backToNewRegister()
                            }}
                        >
                            New Registration
                        </button>
                    </div>
                </div>
            ) : (
                <div className="w-9 maxW-370 m-auto pt-4 pb-3">
                    <div className="text-center">
                        <img src={TriangleIcon} alt="warning" />
                        <p className="fw-lighter font-size-lg mt-3 mb-3 text-error-red">
                            You are already registered with mobile number{' '}
                            <span className="text-dark-grey"> {maskedMobNum(studentMobNum)}</span>
                        </p>
                    </div>

                    <div className="text-center" style={{ fontWeight: 500 }}>
                        <p className="text-grey-black font-size-mds mb-0 fw-500">
                            Student Name:{' '}
                            <span className="text-light-grey-200">
                                {studentDetails.student_name}
                            </span>
                        </p>

                        <p className="text-grey-black font-size-mds mb-0 fw-500">
                            Roll number:{' '}
                            <span className="text-aqua">
                                {studentDetails.student_roll_no}
                            </span>
                        </p>

                        <p className="font-size-mds fw-500 text-grey-black">
                            {studentDetails.class_stream_name}
                        </p>
                    </div>

                    <p className="w-9 m-auto text-center font-size-sm">
                        Wishing you success on your exam! Looking forward to having
                        you join our institute
                    </p>

                    <div className="d-flex align-items-center bg-beige text-brown rounded py-2 px-4 mt-4 mx-2">
                        <WarningIcon fill="transparent" stroke="#705010" />

                        <div className="font-size-xs ms-4">
                            <div>Capture your login details!</div>
                            <div>Screenshot now to secure your credentials</div>
                        </div>
                    </div>

                    <div className="rounded-10px my-4 py-3 px-4 bg-off-white">
                        <p className="font-size-md fw-lighter mb-0">View Results</p>
                        <p
                            className="font-size-xs pb-2"
                            style={{ borderBottom: '2px dotted #757575' }}
                        >
                            
                             {Domain.includes('akthedashboard') ? 'Post examination you can view your result on the AKTHE dashboard' : ' Post examination you can view your result on the ANTHE dashboard'}
                        </p>

                        <p className="font-size-sm mb-0 fw-500">
                            Roll number: {studentDetails.student_roll_no}
                        </p>
                        <p className="font-size-sm fw-500">
                            Password: {String(studentDetails.student_dob).replace(/-/g, "/")}
                        </p>

                        <a
                            target="_self"
                            href={studentRegister.dashboard_link}
                            className="font-size-sm text-aqua cursor-pointer"
                        >
                            Click here to go to dashboard
                        </a>
                    </div>
                </div>
            )}
        </>
    )
}

export default UserAlreadyRegistered
